import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Button, DeleteConfirmationModal, PlusIcon } from "components";
import { HomeScreenLayout } from "components/layout/HomeScreenLayout";
import { DataTable } from "components/table/DataTable";
import { useEffect, useState } from "react";
import { DrawerComponent } from "./components/DrawerComponent";
import {
  useCreateBillingTemplate,
  useGetAllBillingTemplate,
  useDeleteBillingTemplate,
} from "controller";
import toast from "react-hot-toast";
import { useMainStore } from "controller/store/mainStore";
import { useMixpanelPageViewTracker } from "utilz/helpers";
import type { BillingTemplateListItem } from "shared";
import BillingTemplate from "./components/BillingTemplate";

export const ServiceDeskBillingEmailTemplateComponent = (data: any) => {
  useMixpanelPageViewTracker({ event: "billing_templates_page_visited" });
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [mode, setMode] = useState<any>({
    method: "create",
    data: null,
    primaryButtonDisable: false,
  });

  const openCreateDrawer = () => {
    setMode({ method: "create", data: null, primaryButtonDisable: false });
    setIsDrawerOpen(true);
  };

  const openEditDrawer = (template: BillingTemplateListItem) => {
    setMode({ method: "update", data: template, primaryButtonDisable: false });
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const componentName = "Billing Templates";

  return (
    // <Box sx={{ padding: 3 }}>
    <HomeScreenLayout
      title="Billing Templates"
      rightActionComponent={
        <Stack direction={"row"} gap={"24px"}>
          <Button
            endIcon={<PlusIcon />}
            onClick={openCreateDrawer}
          >
            Template
          </Button>
        </Stack>
      }
    >
      <DrawerComponent
        {...{ isDrawerOpen, closeDrawer, componentName, mode }}
      />
      <Box sx={{ paddingX: "32px" }}>
        <BillingTemplate onEdit={openEditDrawer} />
      </Box>
    </HomeScreenLayout>
  );
};
